import { inject as n, computed as u } from "vue";
import { enUS as e } from "./ghl-ui.es330.js";
function s(t) {
  const o = n("customLocale", null) || {};
  return u(() => {
    var r;
    return ((r = o == null ? void 0 : o.value) == null ? void 0 : r[t]) ?? e[t];
  });
}
export {
  s as default
};
